import React, { Component } from "react"
import { Icon, Button } from "antd";

export default class Draggable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeSect: {},
            activeLect: {},
            sections: [],
            currentlyOver: {},
            currentlylectOver: {},
            currentlylectOverkey: null,
            activeLectkey: null
        }
    }

    componentWillMount() {
        const { sections } = this.props;
        console.log(sections)
        sections.sort((a, b) => a.position > b.position ? 1 : -1)
        sections.map((sect) => {
            sect.lectures.sort((a, b) => a.position > b.position ? 1 : -1)
        })
        this.setState({ sections })
    }

    onDragOver = (e, sect, type) => {
        var { sections, activeSect } = this.state
        // console.log(this.state)
        // if((sect.title !== activeSect.title) && activeSect.title){
        //     var  newIndex = sections.findIndex((section)=>section.id === sect.id)
        //     var newList = sections.filter((section)=>section.id !== activeSect.id )
        //     newList.splice(newIndex ,0,activeSect)
        //     this.setState({sections:newList})
        // }   
    }

    currentOver = (e, sect) => {
        // console.log(sect)
        this.setState({
            currentlyOver: sect
        })
    }

    leccurrentOver = (e, key, lect) => {
        // console.log(sect)
        this.setState({
            currentlylectOver: lect,
            currentlylectOverkey: key
        })
    }

    onDrag = (e, activeSect) => {
        e.target.style.opacity = '0.4';
        this.setState({ activeSect })
    }

    onLectDrag = (e, key, activeLect) => {
        e.target.style.opacity = '0.4';
        this.setState({
            activeLect,
            activeLectkey: key
        })
    }

    onDrop = (e) => {
        e.target.style.opacity = '1';
        var { sections, activeSect, currentlyOver } = this.state
        console.log(this.state)
        if (currentlyOver.title && activeSect.title && activeSect.title !== currentlyOver.title) {
            var activepos = sections.findIndex(section => section.id === activeSect.id);
            var currentlypos = sections.findIndex(section => section.id === currentlyOver.id);
            var newlist = sections
            newlist.splice(currentlypos, 1, activeSect)
            newlist.splice(activepos, 1, currentlyOver)
            newlist[currentlypos].position = currentlypos
            newlist[activepos].position = activepos
            this.setState({
                sections: newlist
            }, () => {
                console.log(this.state)
            })
        }
    }

    onLectDrop = (e) => {
        e.target.style.opacity = '1';
        var { sections, activeLect, currentlylectOver,
            activeLectkey, currentlylectOverkey, activeSect } = this.state
        console.log(this.state)
        if (currentlylectOver.title && activeLect.title && currentlylectOver.title !== activeLect.title && activeSect.position === activeLectkey && activeSect.position === currentlylectOverkey) {
            var activepos = sections[activeLectkey].lectures.findIndex(lecture => lecture.id === activeLect.id);
            var currentlypos = sections[activeLectkey].lectures.findIndex(lecture => lecture.id === currentlylectOver.id);
            var newlist = sections[activeLectkey].lectures
            newlist.splice(currentlypos, 1, activeLect)
            newlist.splice(activepos, 1, currentlylectOver)
            newlist[currentlypos].position = currentlypos
            newlist[activepos].position = activepos
            sections[activeLectkey].lectures = newlist
            this.setState({
                sections
            }, () => {
                console.log(this.state)
            })
            // console.warn('lets go!')
        }
        // this.setState({ activeLect: {}, activeSect: {} })
    }

    onLectDragOver = (e, lect, sectId, type) => {
        var { sections, activeLect } = this.state
        // if (type !== "lecture") return false;
        // if ((lect.title !== activeLect.title) && activeLect.title) {
        //     var newIndex = sections[sectId].lectures.findIndex((lecture) => lecture.id === lect.id)
        //     var newList = sections[sectId].lectures.filter((lecture) => lecture.id !== activeLect.id)
        //     newList.splice(newIndex, 0, activeLect)
        //     sections[sectId].lectures = newList;
        //     this.setState({ sections })
        // }5rf
    }

    save = () => {
        const { sections } = this.state;
        this.props.editSection(sections, this.props.courseId)
        window.scrollTo(0, 0);
    }

    render() {
        const { sections } = this.state
        return (
            <div id="draggable">
                <h5>Arrange lectures <Icon type="fullscreen-exit" /></h5>
                <hr />
                {sections.map((sect, key) => (
                    <div
                        className="sect-box"
                        key={key}
                        draggable={true}
                        onDragOver={(e) => this.currentOver(e, sect)}
                        onDragStart={(e) => this.onDrag(e, sect)}
                        onDragEnd={this.onDrop}
                        onDrop={this.onDrop}
                    >
                        <div className="sect-title"> {sect.title} </div>
                        {sect.lectures.map((lect, i) => (
                            <div
                                key={i}
                                draggable={true}
                                onDragOver={(e) => this.leccurrentOver(e, key, lect)}
                                onDragStart={(e) => this.onLectDrag(e, key, lect)}
                                onDragEnd={this.onLectDrop}
                                onDrop={this.onLectDrop}
                                className="lect-box">
                                <i className="fas fa-arrows-alt"></i>
                                <div
                                    className="lect-title"
                                    key={i}
                                >{lect.title}

                                </div>
                            </div>
                        ))}
                    </div>
                ))}
                <Button type="ghost" onClick={this.save}>Save</Button>
            </div>
        )
    }
}
